import React from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import { Link } from 'react-router-dom';

import LockedContent from 'components/common/LockedContent';

const AnalyticsLockedContent = ({ children }) => (
  <Translation>
    {(t) => (
      <LockedContent
        text={
          <>
            {t("Advanced analytics is available on the PRO plan.")} <br />{t("Please upgrade")} <Link to="/billing">{t("here")}</Link>
          </>
        }
      >
        {children}
      </LockedContent>
    )}
  </Translation>
);

AnalyticsLockedContent.propTypes = {
  children: PropTypes.object.isRequired,
};

export default AnalyticsLockedContent;
